import { render, staticRenderFns } from "./UserEvents.vue?vue&type=template&id=4a416c34&scoped=true"
import script from "./UserEvents.vue?vue&type=script&lang=js"
export * from "./UserEvents.vue?vue&type=script&lang=js"
import style0 from "./UserEvents.vue?vue&type=style&index=0&id=4a416c34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a416c34",
  null
  
)

export default component.exports